import { render, staticRenderFns } from "./ApplicationConfig.vue?vue&type=template&id=b4bd4fdc&scoped=true"
import script from "./ApplicationConfig.vue?vue&type=script&lang=js"
export * from "./ApplicationConfig.vue?vue&type=script&lang=js"
import style0 from "./ApplicationConfig.vue?vue&type=style&index=0&id=b4bd4fdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bd4fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4bd4fdc')) {
      api.createRecord('b4bd4fdc', component.options)
    } else {
      api.reload('b4bd4fdc', component.options)
    }
    module.hot.accept("./ApplicationConfig.vue?vue&type=template&id=b4bd4fdc&scoped=true", function () {
      api.rerender('b4bd4fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelCode/components/ApplicationConfig.vue"
export default component.exports